import { useState, useEffect } from 'react';
import { Wrench } from 'lucide-react';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { PriceDisplay } from '../components/PriceDisplay';
import { useLanguage } from '../config/language';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function SpareParts() {
  const { t, language } = useLanguage();
  const isAr = language === 'ar';
  const [parts, setParts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchParts();
  }, []);

  const fetchParts = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/spare-parts`);
      setParts(response.data.data || []);
    } catch (error) {
      console.error('Error fetching spare parts:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen">
      <section 
        className="relative h-40 flex items-center justify-center"
        style={{
          backgroundImage: 'url(https://images.pexels.com/photos/7565157/pexels-photo-7565157.jpeg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0 bg-[#F5A962]/80"></div>
        <div className="relative z-10 text-center text-white">
          <Wrench className="h-10 w-10 mx-auto mb-2" />
          <h1 className="text-3xl font-bold font-heading" data-testid="spare-parts-title">
            {t('home.sparePartsTitle')}
          </h1>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {loading ? (
          <div className="text-center py-20">
            <p className="text-[#475569] text-xl">{t('common.loading')}</p>
          </div>
        ) : parts.length === 0 ? (
          <div className="text-center py-20">
            <Wrench className="h-20 w-20 mx-auto mb-4 text-[#94A3B8]" />
            <p className="text-[#475569] text-xl mb-4">
              {isAr ? 'لا توجد قطع غيار متاحة حالياً' : 'No spare parts available at the moment'}
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {parts.map((part) => (
              <div 
                key={part.id} 
                className="bg-white rounded-2xl overflow-hidden border border-[#E2E8F0] card-hover"
                data-testid={`part-${part.id}`}
              >
                <img 
                  src={part.image_url} 
                  alt={part.name}
                  className="w-full h-48 object-cover"
                />
                <div className="p-6">
                  <h3 className="text-lg font-bold text-[#0F172A] font-heading mb-1">
                    {isAr ? part.name_ar : part.name}
                  </h3>
                  <p className="text-xs text-[#94A3B8] mb-4">{part.brand} - {part.model}</p>
                  
                  <div className="flex items-center justify-between">
                    <PriceDisplay price={part.price} className="text-xl font-bold text-[#F5A962]" size="md" />
                    <Button size="sm" className="btn-secondary text-white" data-testid={`add-cart-${part.id}`}>
                      {isAr ? 'أضف' : 'Add'}
                    </Button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
